import { render, staticRenderFns } from "./related-tags-config.component.vue?vue&type=template&id=9028c6bc&scoped=true"
import script from "./related-tags-config.component.vue?vue&type=script&lang=ts"
export * from "./related-tags-config.component.vue?vue&type=script&lang=ts"
import style0 from "./related-tags-config.component.vue?vue&type=style&index=0&id=9028c6bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9028c6bc",
  null
  
)

export default component.exports